import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "../components/AlertSettingsStyles";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import SuccessMessage from "../components/SuccessMessage";
import ErrorMessage from "../components/ErrorMessage";

export const email_report_map = {
  0: "never",
  1: "daily",
  2: "weekly",
  3: "monthly",
};

// Email_report
// 0: Never, 1: Daily, 2: Weekly, 3: Monthly

let EmailReportSettings = (props) => {
  const renderError = (props) => {
    const {
      meta: { touched, error, warning },
    } = props;
    return (
      <div>
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  };
  const renderRadio = (props) => {
    const {
      meta: { touched, error, warning },
    } = props;
    return (
      <span>
        <div className={css(styles.checkboxWrapper)}>
          <div className={css([styles.radio])}>
            <span
              className={css([
                styles.radioIcon,
                props.input.checked && styles.radioIconChecked,
              ])}
            />
          </div>
          <strong className={css(styles.label)}>{props.label}</strong>
        </div>
        <input
          className={css(styles.hidden)}
          {...props.input}
          type={props.type}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </span>
    );
  };
  const { handleSubmit, submit, submitFailed, submitSucceeded } = props;

  return (
    <form onSubmit={handleSubmit}>
      <h2 className={css(styles.header2)}>Email Report</h2>
      <p className={css(styles.microcopy)}>
        How often would you like to receive a summary of all alerts and
        activity?
      </p>
      <div>
        <label>
          <Field
            name="email_report"
            component={renderRadio}
            type="radio"
            id="email_never"
            value="never"
            label={"Never"}
            onChange={(e) => {
              setTimeout(() => {
                submit("email-report-settings");
              }, 500);
            }}
          />
        </label>
        <label>
          <Field
            name="email_report"
            component={renderRadio}
            type="radio"
            id="email_daily"
            value="daily"
            label={"Daily"}
            onChange={() => {
              setTimeout(() => {
                submit("email-report-settings");
              }, 500);
            }}
          />
        </label>
        {/* <label>
          <Field
            name="email_report"
            component={renderRadio}
            type="radio"
            id="email_weekly"
            value="weekly"
            label={"Weekly"}
            onChange={() => {
              setTimeout(() => {
                submit("email-report-settings");
              }, 500);
            }}
          />
        </label> */}
        <label>
          <Field
            name="email_report"
            component={renderRadio}
            type="radio"
            id="email_monthly"
            value="monthly"
            label={"Monthly"}
            onChange={() => {
              setTimeout(() => {
                submit("email-report-settings");
              }, 500);
            }}
          />
        </label>
        <div>
          <Field name="hidden_field" component={renderError} />
        </div>
        {submitSucceeded && <SuccessMessage message="Preference saved" />}
        {submitFailed && <ErrorMessage message="Could not save preference" />}
      </div>
    </form>
  );
};

const mapStateToProps = (state) => {
  if (state.account.accountDetail[1]) {
    let initialValues = {
      email_report:
        state.account.accountDetail[1] &&
        email_report_map[state.account.accountDetail[1].email_report],
    };

    return {
      initialValues,
      account: state.account,
    };
  }
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "email-report-settings",
  })(EmailReportSettings)
);
